
import { ConstructionWork } from "modules/construction-work/src/Common/interface";
import {PropType} from 'vue';

export default {
    name: 'WorkItem',
    props: {
        work: {
            type: Object as PropType<ConstructionWork>,
            required: true
        },
        statuses: {
            type: Object,
            default: () => ({})
        },
        executors: {
            type: Object,
            default: () => ({})
        },
        categories: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            user: (window as any).BaseApp.user || null,
        }
    },
    computed: {
        workStatus() {
            if (!this.work || !this.work.status || !this.statuses) return null;
            return this.statuses[this.work.status] || null;
        },
        workExecutor() {
            if (!this.work || !this.work.executor || !this.executors) return null;
            return this.executors[this.work.executor] || null;
        },
        workCategory() {
            if (!this.work || !this.work.category || !this.categories) return null;
            return this.categories[this.work.category] || null;
        }
    },
    methods: {
        getSvgWithColor(svgContent: string, fillColor: string): string {
            if (!svgContent || !fillColor) return svgContent || '';
            return svgContent.replace(/fill="white"/g, `fill="${fillColor}"`);
        }
    }
};
